<template>
    <div class="module1">
        <div class="container">
            <!-- 左侧文字内容 -->
            <div class="content">
                <h1>物业收费管理系统</h1>
                <p>适用于社区 园区 写字楼等</p>
                <p>以上百家成功案例经验，量身定制合理的开发方案</p>
                    
                <a href="tel:13509189441" target="_self" class="contact_link">
                    <img src="../../../assets/icon/phone.png" />
                    <span>联系我们</span>
                </a>

                <a class="contact_link">
                    <img src="../../../assets/icon/qq.png" />
                    <span>45286653</span>
                </a>

                <!-- <el-button size="large" @click="dialogVisible = true">
                    联系我们
                </el-button> -->
            </div>

            <el-dialog
                v-model="dialogVisible"
                title="联系我们"
            >
                <div class="contact">
                    <div>
                        <span>联系人：韩经理</span>
                    </div>
                    <div>
                        <span>联系电话：</span>
                        <a href="tel:13509189441" target="_self">13509189441</a>
                    </div>
                </div>
                <template #footer>
                <div class="dialog-footer">
                    <el-button @click="dialogVisible = false">
                        确定
                    </el-button>
                </div>
                </template>
            </el-dialog>

            <!-- 右侧图片内容 -->
            <div class="image-container">
                <img src="../../../assets/image/m1_img1.png" alt="示例图" />
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue';

let dialogVisible = ref(false);
</script>
<style scoped lang="scss">
.module1 {
    background: linear-gradient(to right, #4a90e2, #1fb6ff);
    background: url(../../../assets/image/m1_bg.png) no-repeat;
    background-size: 100% 100%;
    padding: 50px 20px;
    color: #fff;

    ::v-deep .el-dialog{
        background: #70b2f6;
        text-align: center;
    }
    ::v-deep .el-dialog__title {
        color: #fff;
    }

    .contact{
        font-size: 16px;
        text-align: left;
        color: #fff;
        a{
            text-decoration: none;
            color: #fff;
        }
    }

    .container {
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-wrap: wrap;
        max-width: 1200px;
        margin: 0 auto;
    }

    .content {
        flex: 1;
        max-width: 600px;
        .contact_link{
            background-color: #fff;
            text-decoration: none;
            color: #606266;
            display: flex;
            align-items: center;
            width: max-content;
            padding: 8px 15px;
            border-radius: 5px;
            margin-top: 18px;
            span{
                margin-left: 8px;
            }
            img{
                width: 18px;
                height: 18px;
            }
        }
    }

    .content h1 {
        font-size: 36px;
        margin-bottom: 20px;
    }

    .content p {
        font-size: 18px;
        margin: 10px 0;
    }

    .el-button {
        margin-top: 20px;
    }
    .image-container {
        flex: 1;
        max-width: 600px;
        text-align: center;
    }

    .image-container img {
        max-width: 100%;
        height: auto;
    }

    @media (max-width: 768px) {
        .container {
            flex-direction: column;
            text-align: center;
        }

        .contact_link{
            margin: 0 auto;
        }

        .content h1 {
            font-size: 28px;
        }

        .content p {
            font-size: 16px;
        }

        .image-container {
            margin-top: 20px;
        }
    }
}
</style>